export const YOUTUBE_URL_BASE = 'https://www.youtube.com/watch?v=';
